import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { PageTitle, PaperWithTitle, StripeForm, PrimaryButton } from '../../../components';
import { useClinic } from '../../../../model/hooks/clinic/ClinicHooks';
export const ChangeCreditCard = () => {
    const { t } = useTranslation();
    const { loadCreditCard, loading } = useClinic();
    const [isRegisted, setIsRegisted] = useState(false);
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [last4, setLast4] = useState('');
    const [expMonth, setExpMonth] = useState(0);
    const [expYear, setExpYear] = useState(0);
    useEffect(() => {
        const f = async () => {
            var _a, _b, _c, _d;
            const result = await loadCreditCard();
            // クレジットカードを登録済みの場合は登録済みのカード情報を表示
            if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.isRegisteredCard) {
                setLast4((_b = result.data) === null || _b === void 0 ? void 0 : _b.last4);
                setExpMonth((_c = result.data) === null || _c === void 0 ? void 0 : _c.expMonth);
                setExpYear((_d = result.data) === null || _d === void 0 ? void 0 : _d.expYear);
                setIsRegisted(true);
            }
        };
        f();
    }, []);
    const onClickUpdateMode = () => setIsUpdateMode(true);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('アカウント情報')),
        React.createElement(SGrid, { container: true, justify: "center" },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(PaperWithTitle, { title: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u767B\u9332", titleAlign: "center" },
                    React.createElement(SGrid, { container: true, spacing: 3, justify: "center" }, loading ? (React.createElement(CircularProgress, { size: 30 })) : (React.createElement(React.Fragment, null,
                        isRegisted && (React.createElement(React.Fragment, null,
                            React.createElement(Grid, { item: true, xs: 11 },
                                React.createElement(TextField, { required: true, label: t('現在のクレジットカード番号'), value: `****-****-****-${last4}`, fullWidth: true, disabled: true })),
                            React.createElement(Grid, { item: true, xs: 11 },
                                React.createElement(TextField, { required: true, label: t('現在の有効期限'), value: `${expMonth}/${expYear}`, fullWidth: true, disabled: true })),
                            isUpdateMode || (React.createElement(Grid, { item: true, xs: 6, style: { marginTop: '16px' } },
                                React.createElement(PrimaryButton, { loading: false, fullWidth: true, onClick: onClickUpdateMode }, t('クレジットカード情報を更新する')))))),
                        (!isRegisted || isUpdateMode) && (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(StripeForm, null)))))))))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
